<template lang="pug">
  app-button(color="#959595" simple @click="$emit('click')")
    slot
</template>

<script>
export default {
  name: 'app-button-cancel'
}
</script>